module.exports = __webpack_public_path__ + "img/blue_169.19b2f3f1.png";